// Default replacement values for script variable tags (location-based data)
export const SCRIPT_VARIABLE_DEFAULTS: Record<string, string> = {
    "[[APPR]]": "1.25%",
    "[[APPR1]]": "5.4%",
    "[[APPR5]]": "28.0%",
    "[[COUNTY]]": "Sample County",
    "[[GAIN5]]": "109,000",
    "[[GAINHALF]]": "4,900",
    "[[MEDHOMEPRICE]]": "$540,000",
    "[[MORELESS]]": "more",
    "[[POPULATION]]": "30,000",
};

// Substitutions for Braze email templates — replaces location-based variables with defaults.
// [[FIRSTNAME]] and [[FULLNAME]] are intentionally left intact so the template can substitute
// them via Liquid replace + {% capture %} using Braze personalization tags.
export const SCRIPT_EMAIL_REPLACEMENTS: Record<string, string> = {
    ...SCRIPT_VARIABLE_DEFAULTS,
};

/**
 * Substitutions for preview contexts (landing page, card previews).
 * When a name is provided, [[FIRSTNAME]] and [[FULLNAME]] are replaced with the user's name.
 * Without a name they are left as literal placeholders.
 */
export const getScriptPreviewReplacements = (name?: string): Record<string, string> => ({
    ...SCRIPT_VARIABLE_DEFAULTS,
    ...(name
        ? {
              "[[FIRSTNAME]]": name.split(" ")[0],
              "[[FULLNAME]]": name,
          }
        : {}),
});

/**
 * Strips HTML tags from a script body, preserving line breaks from block elements
 * and decoding common HTML entities. Safe to use server-side and client-side.
 */
export const cleanScriptBody = (body: string): string => {
    return body
        .replace(/<\/?(h[1-6]|p|div|br|li|section|article)[^>]*>/gi, "\n")
        .replace(/<\/?[^>]+>/gi, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\n{2,}/g, "\n")
        .trim();
};

/**
 * Replaces all [[VARIABLE]] placeholders in text with values from the replacements map.
 */
export const replaceScriptVariables = (text: string, replacements: Record<string, string>): string => {
    let result = text;
    for (const [key, value] of Object.entries(replacements)) {
        result = result.split(key).join(value);
    }
    return result;
};
